// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3ethS","title":"FrontImage_title__1ghq_"};